import { AxiosResponse } from 'axios'
import { ILoginResponseModel, IResponseModelWrapper } from '@/api/typings-generated/general'
import request from '@/utils/request'

export class AuthApi {
  static async status(): Promise<IResponseModelWrapper<ILoginResponseModel>> {
    const axiosResponse: AxiosResponse = await request({
      url: process.env.BASE_URL + 'api/auth/status',
      method: 'get'
    })

    return axiosResponse.data
  }

  static async login(
    username: string,
    password: string
  ): Promise<IResponseModelWrapper<ILoginResponseModel>> {
    const axiosResponse: AxiosResponse = await request({
      url: process.env.BASE_URL + 'api/auth/login',
      method: 'post',
      data: {
        username,
        password
      }
    })

    // if not OK 200, presume its an error
    if (axiosResponse.status !== 200) {
      return {
        isSuccessful: false,
        payload: null,
        message: axiosResponse.statusText
      }
    }

    return axiosResponse.data
  }

  static async loginAd(
  ): Promise<IResponseModelWrapper<ILoginResponseModel>> {
    const axiosResponse: AxiosResponse = await request({
      url: process.env.BASE_URL + 'api/auth-ad/login',
      method: 'get'
    })

    // if not OK 200, presume its an error
    if (axiosResponse.status !== 200) {
      return {
        isSuccessful: false,
        payload: null,
        message: axiosResponse.statusText
      }
    }

    return axiosResponse.data
  }

  static async logout(): Promise<IResponseModelWrapper<any>> {
    const axiosResponse: AxiosResponse = await request({
      url: process.env.BASE_URL + 'api/auth/logout',
      method: 'post',
      data: { }
    })

    // if not OK 200, presume its an error
    if (axiosResponse.status !== 200) {
      return {
        isSuccessful: false,
        payload: null,
        message: axiosResponse.statusText
      }
    }

    return axiosResponse.data
  }
}
